/**
 * api接口统一管理
 */
import http from './http'
// 现在，例如我们有这样一个接口，是一个post请求：

// http://www.baiodu.com/api/v1/users/my_address/address_edit_before
// 我们可以在api.js中这样封装：
export const getBanner = data => http.get("banner", data);

export const getWxLogin = data => http.get("weixin/login");

export const getColumn = data => http.get("column", data);
//获取活动列表
export const getAclist = data => http.get('_ac', data)
//获取文章列表 获取文章详情 
export const getNewslist = data => http.get('_art/alst', data)
//获取文章分类
export const getCategory = data => http.get('_art/category', data)
//获取营地列表
export const getCamplist = data => http.get('_camp', data)
//获取线路列表
export const getLinelist = data => http.get('_line', data)
//获取课程分类
export const getPac = data => http.get('_camp/pac', data)
//获取课程列表
export const getCourselist = data => http.get('_camp/lesson', data)

export const getActypes = data => http.get('_ac/acategory', data)
export const getActivitylist = data => http.get('_ac', data)

export const getSca = data => http.get('sca', data)
export const getPc = data => http.get('_pc', data)
export const getNt = data => http.get('nt', data)
export const getAdvbanner = data => http.get('_pc/advbanner', data)

export const getTeacher = data => http.get('_teacher', data)
export const getlinetype = data => http.get('_line/category', data)
export const getMapcamp = data => http.get('_pc/camp', data)
export const getRegion = data => http.get('_region', data)
export const getPlate = data => http.get('_pc/modules', data)
export const getTraveler = data => http.get('_third/employ', data)
export const yzmsms = data => http.post('weixin/sms', data)
export const register = data => http.post('weixin/register', data)
export const bindmentor = data => http.post('_teacher/pbind', data)
export const searchcamp = data => http.post('_pc/verifyCamp', data)
export const bindcamp = data => http.post('_pc/bindCamp', data)
export const getCamplisttest = data => http.get('_pc/campinfos', data)
export const searchtraveler = data => http.post('_pc/verifyEmploy', data)
export const bindtraveler = data => http.post('_pc/bindEmploy', data)
export const getexpert = data => http.get('_pc/expert', data)
export const getnewscomment = data => http.get('_comment/art', data)
export const phonelogin = data => http.post('weixin/userlogin', data)
export const checktoken = data => http.get('tk/ct', data)
export const regettoken = data => http.get('tk', data)
export const newsSendcomment = data => http.post('_comment/art', data)
export const newsSendreply = data => http.post('_comment/artreply', data)
export const getcampcomment = data => http.get('_evaluate/evaluate', data)
export const getactcomment = data => http.get('_evaluate/evaluate', data)
export const ratecomment = data => http.post('_evaluate/evaluate', data)
export const getuserdata = data => http.get('weixin/ml', data)
export const getTempKeys = data => http.get('weixin/getTempKeys', data)
export const checkUpload = data => http.post('_ac/afile', data)
export const getHistoryOrgList = data => http.post('_ac/getHistoryOrgList', data)
export const handleUploadExcel = data => http.post('_ac/handleUploadExcel', data)
export const checkPiccData = data => http.post('_picc/checkPiccData', data)
export const createPiccOrder = data => http.post('_picc/createOrder', data)
export const getPayOrderUrl = data => http.post('_picc/getPayOrderUrl', data)
export const subOrgRegister = data => http.post('_org/register', data)
export const getbottomnav = data => http.get('_pc/pcnavigation', data)
export const commentdelete = data => http.post('_evaluate/edel', data)
export const resetpassword = data => http.post('weixin/forgetpwd', data)
export const getsys = data => http.get('_sys', data)
export const upadvocate = data => http.post('_pc/suggest', data)
export const looksecretup = data => http.get('_look', data)

export const getcodepre = data => http.get('_pc/open', data)
export const loginget = data => http.get('_pc/openlogin', data)
export const bindphone = data => http.post('_pc/userlogin', data)
export const getodc = data => http.post('_pc/odc', data)
export const getpostlist = data => http.get('_pc/opost', data)
export const getpostlevel = data => http.get('_pc/olevel', data)
export const OAregister = data => http.post('_pc/omember', data)
export const getcamptags = data => http.get('_camp/tags', data)
export const getsitelist = data => http.get('_pc/subcity', data)
export const getpdfUrl = data => http.get('_pc/pdf', data)
// export const getBanner = p => http.get('banner', p);
// 我们定义了一个apiAddress方法，这个方法有一个参数p，p是我们请求接口时携带的参数对象。而后调用了我们封装的post方法，post方法的第一个参数是我们的接口地址，第二个参数是apiAddress的p参数，即请求接口时携带的参数对象。最后通过export导出apiAddress。
